

import {
    EnumUtility,
    ApiManager,
    sessionService,
    DocumentUtility,
    SessionManager,
    batchDataService
} from '../components/ComponentsLibrary';


// Perform Save of Document after ROTATION of One or More pages in a document
// The page could be rotated to left, right or multiple rotate to turn the page upside down
const PerformSaveAfterRotateOperation = async (pdfViewerRef, batchDocumentID, setOperations, getSelectedPageIndexes) => {
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    let docSplitData = batchDataService.getSplitDocumentData();
     // Check if batchInstance exists
    if (!docSplitData || !docSplitData.batchInstance) {
        console.warn('No batch instance available for save operation');
        return { hasOperations: false };
    }

    return new Promise((resolve) => {
        //setting the operations
        setOperations((operations) => {
        // Check if operations is defined and has content
        if (!operations || operations.length === 0) {
            console.warn('No operations to save - skipping save operation');
            resolve({ hasOperations: false });
            return operations; // Return early without attempting to export
        }

        //this is just a custom array to target all pages
        //but you can use the getSelectedPageIndexes callback to only get the selected pages
        const normalizingOperations = operations.reduce(
            (acc, ops) => (                
                ops.size > 0 ? acc.concat(ops.get(0)) : acc.concat(ops)
            ),
            []
        );

        // Additional check after normalization
        if (normalizingOperations.length === 0) {
            console.warn('No normalized operations to save - skipping save operation');
            resolve({ hasOperations: false });
            return operations;
        }

        console.log(normalizingOperations);
        docSplitData.batchInstance
        .exportPDFWithOperations([
            //pass the operations from the Doc Editor to the exportPDFWithOperations
            ...normalizingOperations,
        ])
        .then(async (buffer) => {
            docSplitData.currentDocument_Blob = new Blob([buffer], { type: "application/pdf" });

            const paramsBatchDoc = {
                batchDocumentID: batchDocumentID
            }

            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;

            let batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);
            console.log("batchDocAPi response save after rotate", batchDocApiData ,"for selected Doc", paramsBatchDoc)


            const updatedDocValues = {
                ...batchDocApiData,
                userLoginID: loginLegacyUserID,
                orgID: loginStateID,
                newBatchDocumentID: paramsBatchDoc.batchDocumentID,
                fKM_UserLoginID: loginLegacyUserID,
                KM_YTracSiteID: loginStateID,
                fKM_IndexUserLoginID: batchDocApiData.fkM_IndexUserLoginID,
                fKM_LastIndexUserLoginID: batchDocApiData.fkM_LastIndexUserLoginID,
                docPageCount: batchDocApiData.pageCount,
                batchStatus: batchDocApiData.documentStatusID,
                documentTypeID: batchDocApiData.documentTypeID,
                documentName: batchDocApiData.documentName,
                caseNumber: "",
                caseWorker: "",
                cPMemberID: "0",
                nCPMemberID: "0",
                masterServerDBSchema
            };

            const settingDetailValue = SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey);
            const siteSettingDetail = JSON.parse(settingDetailValue);
            docSplitData.basePath = siteSettingDetail.DocumentPath;
            //docSplitData.basePath = SessionManager.GetValueFromSession(SessionManager.DocumentPathKey);

            if (batchDocApiData.documentLocation.slice(-3).toLowerCase() === "pdf") {
                docSplitData.documentUNCPath = docSplitData.basePath + batchDocApiData.batchPath + "\\" + batchDocApiData.documentLocation;
            } else {
                docSplitData.documentUNCPath = docSplitData.basePath + batchDocApiData.batchPath + "\\" + replaceExtensionWithPdf(batchDocApiData.documentLocation);
                updatedDocValues.documentLocation = replaceExtensionWithPdf(batchDocApiData.documentLocation);
                const postResponseData = await ApiManager.PostBatchDocumentToApi(updatedDocValues);  // Update the current document with the new PDF extension
            }

            console.log("Update Existing Document Path: " + docSplitData.documentUNCPath);

            await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);

            if (pdfViewerRef.current) {
                await pdfViewerRef.current.handleDocumentExport(buffer, docSplitData.batchInstance);
            } 

        
            // Resolve with success indicating operations were performed
            resolve({ hasOperations: true });

        })
        .catch((error) => {
            console.error('Error during save operation:', error);
            resolve({ hasOperations: false });
        });

            return operations;
        }, !1);
    });
    //return { documentBuffer: docBuffer, batchInstance: docSplitData.batchInstance };
}

function replaceExtensionWithPdf(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return fileName; // No dot found, return the original string
    }
    return fileName.substring(0, lastDotIndex + 1) + 'pdf';
}


const BusinessUtility = {
    PerformSaveAfterRotateOperation,
    //GetCaseRegexMessage,
    //GetBatchDocumentByID,
    replaceExtensionWithPdf
};

export default BusinessUtility;